export default __webpack_public_path__ + "static/media/AppStore.57b4bc48.png";